const lut: string[] = []
for (let i = 0; i < 256; i++) {
	lut[i] = (i < 16 ? '0' : '') + i.toString(16)
}

export default function () {
	const k = [
		'x',
		'x',
		'x',
		'x',
		'-',
		'x',
		'x',
		'-',
		'4',
		'x',
		'-',
		'y',
		'x',
		'-',
		'x',
		'x',
		'x',
		'x',
		'x',
		'x',
	]
	let u = ''
	let i = 0
	let rb = (Math.random() * 0xffffffff) | 0
	while (i++ < 20) {
		const c = k[i - 1]
		const r = rb & 0xff
		const v = c == 'x' ? r : c == 'y' ? (r & 0x3f) | 0x80 : (r & 0xf) | 0x40
		u += c == '-' ? c : lut[v]
		rb = i % 4 == 0 ? (Math.random() * 0xffffffff) | 0 : rb >> 8
	}
	return u
}
